/**
 * Dependencies.
 */
import de from './de.translate';
import el from './el.translate';
import en from './en.translate';
import es from './es.translate';
import fi from './fi.translate';
import fr from './fr.translate';
import it from './it.translate';
import pl from './pl.translate';
import pt from './pt.translate';

/**
 * Export.
 */
export default {
  'de-DE': { DASHBOARD: de },
  'el-GR': { DASHBOARD: el },
  'en-US': { DASHBOARD: en },
  'es-ES': { DASHBOARD: es },
  'fi-FI': { DASHBOARD: fi },
  'fr-FR': { DASHBOARD: fr },
  'it-IT': { DASHBOARD: it },
  'pl-PL': { DASHBOARD: pl },
  'pt-PT': { DASHBOARD: pt }
};
